import React from 'react';

import { Container, Col, Row } from 'reactstrap';

import TextBox from '@components/TextBox/TextBox';
import ListBox from '@components/ListBox/ListBox';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const desktop = props => {
  return (
    <React.Fragment>
      <img src={Clouds} alt={'Slider1'} className={'img-fluid'} />
      <Container
        fluid={true}
        className={'abs-container d-flex align-items-center'}
      >
        <Row className={'align-items-center'}>
          <Col md={{ offset: 1, size: 4 }}>
            <TextBox {...props.activeBox} />
          </Col>
          <Col md={props.heightSm ? { size: 6 } : { offset: 1, size: 5 }}>
            <Row>
              {props.boxs.map(box => (
                <ListBox
                  disabled={true}
                  activeBox={props.activeBox.id}
                  id={box.id}
                  key={box.id}
                  title={box.title}
                  click={() => props.click(box)}
                  styles={{ minHeight: '94px' }}
                />
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default desktop;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Benefits/Desktop/Desktop.js